function extractPhoneNumber(textQuery) {
  if (!textQuery) return null;
  const isValidPhone =
    /^(?:\+?\s?\d{0,2}\s?)?(?:\(?\d{2,3}\)?[\s-]?)?\d{4,5}[\s-]?\d{4}$/;

  if (isValidPhone.test(textQuery)) {
    const cleaned = textQuery.replace(/[\s()+-]/g, '');
    return cleaned;
  }

  return textQuery;
}
export default extractPhoneNumber;
